(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-mala"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.__cbMalaInit) return;
    root.__cbMalaInit = true;
    var sticky = root.querySelector('[data-cb-mala-sticky-link]');
    var stickyText = root.querySelector('[data-cb-mala-sticky-text]');
    var stickyShell = root.querySelector('[data-cb-mala-sticky-shell]');
    function setSticky(){
      if(!sticky || !stickyText) return;
      sticky.href = sticky.getAttribute('data-post-url') || sticky.href;
      stickyText.textContent = sticky.getAttribute('data-post-label') || stickyText.textContent;
    }
    setSticky();
    if(stickyShell){
      var stickyTrigger = root.querySelector('[data-cb-mala-sticky-trigger]');
      var stickyOffset = parseInt(stickyShell.getAttribute('data-cb-mala-sticky-offset'), 10);
      if(isNaN(stickyOffset) || stickyOffset < 0) stickyOffset = 0;
      var ticking = false;
      var getStickyThreshold = function(){
        if(!stickyTrigger) return stickyOffset;
        var triggerRect = stickyTrigger.getBoundingClientRect();
        return window.scrollY + triggerRect.bottom;
      };
      var updateStickyVisibility = function(){
        ticking = false;
        stickyShell.classList.toggle('is-visible', window.scrollY >= getStickyThreshold());
      };
      var requestStickyUpdate = function(){
        if(ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateStickyVisibility);
      };
      window.addEventListener('scroll', requestStickyUpdate, { passive:true });
      window.addEventListener('resize', requestStickyUpdate);
      updateStickyVisibility();
    }
    function suppressCardPopup(){
      document.querySelectorAll('#cbtpOverlay,.cbtp__overlay').forEach(function(el){
        el.style.setProperty('display','none','important');
        el.style.setProperty('visibility','hidden','important');
        el.style.setProperty('opacity','0','important');
        el.style.setProperty('pointer-events','none','important');
        el.classList.remove('cbtp--open');
      });
      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow');
    }
    suppressCardPopup();
    if(window.MutationObserver && document.body){
      var popupObserver = new MutationObserver(suppressCardPopup);
      popupObserver.observe(document.body, { childList:true, subtree:true });
    }
    window.addEventListener('scroll', suppressCardPopup, { passive:true });
    [500, 1500, 3000].forEach(function(delay){ window.setTimeout(suppressCardPopup, delay); });
    root.querySelectorAll('[data-cb-mala-quiz-toggle]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var quiz = btn.closest('[data-cb-mala-quiz]');
        if(!quiz) return;
        var v = quiz.querySelector('[data-cb-mala-quiz-verdict]');
        if(!v) return;
        var open = v.hasAttribute('hidden');
        if(open){ v.removeAttribute('hidden'); } else { v.setAttribute('hidden',''); }
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  document.querySelectorAll('[data-cb-mala]').forEach(init);
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector('[data-cb-mala]');
    init(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ky-pierres-hub"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function normalize(value) {
      return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    function hasToken(list, token) {
      return !token || (' ' + (list || '') + ' ').indexOf(' ' + token + ' ') !== -1;
    }

    function init(root) {
      if (!root || root.dataset.kyhReady) return;
      root.dataset.kyhReady = '1';

      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kyh-card]'));
      var grid = root.querySelector('[data-kyh-grid]');
      var empty = root.querySelector('[data-kyh-empty]');
      var count = root.querySelector('[data-kyh-count]');
      var resetButtons = Array.prototype.slice.call(root.querySelectorAll('[data-kyh-reset]'));
      var search = root.querySelector('[data-kyh-search]');
      var state = { intention: '', element: '', chakra: '', q: '' };

      function setActive(group, value) {
        Array.prototype.slice.call(root.querySelectorAll('[data-kyh-group="' + group + '"] [data-kyh-filter="' + group + '"]')).forEach(function (button) {
          button.classList.toggle('kyh-is-active', (button.getAttribute('data-kyh-value') || '') === value);
        });
      }

      function updateChakraCounts() {
        Array.prototype.slice.call(root.querySelectorAll('[data-kyh-chakra-count]')).forEach(function (node) {
          var chakra = node.getAttribute('data-kyh-chakra-count') || '';
          var total = cards.filter(function (card) {
            return hasToken(card.getAttribute('data-chakras'), chakra);
          }).length;
          node.textContent = total + ' pierre' + (total > 1 ? 's' : '');
        });
      }

      function matches(card) {
        if (!hasToken(card.getAttribute('data-intentions'), state.intention)) return false;
        if (state.element) { var cardElement = card.getAttribute('data-element'); if (cardElement !== state.element && cardElement !== 'tous-les-elements') return false; }
        if (!hasToken(card.getAttribute('data-chakras'), state.chakra)) return false;
        if (state.q && normalize(card.getAttribute('data-search')).indexOf(normalize(state.q)) === -1) return false;
        return true;
      }

      function render() {
        var visible = 0;
        cards.forEach(function (card) {
          var show = matches(card);
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (grid) grid.hidden = visible === 0;
        if (empty) empty.hidden = visible !== 0;
        if (count) count.innerHTML = visible === cards.length ? '<strong>' + cards.length + '</strong> pierres' : '<strong>' + visible + '</strong> sur ' + cards.length + ' pierres';
        var active = !!(state.intention || state.element || state.chakra || state.q);
        resetButtons.forEach(function (button) {
          button.classList.toggle('kyh-show', active);
        });
      }

      root.addEventListener('click', function (event) {
        var button = event.target.closest('[data-kyh-filter]');
        if (!button || !root.contains(button)) return;
        var group = button.getAttribute('data-kyh-filter');
        var value = button.getAttribute('data-kyh-value') || '';
        if (group === 'chakra' && state.chakra === value) value = '';
        state[group] = value;
        if (group === 'intention') {
          state.chakra = '';
          setActive('chakra', '');
        }
        setActive(group, value);
        render();
      });

      resetButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          state = { intention: '', element: '', chakra: '', q: '' };
          if (search) search.value = '';
          setActive('intention', '');
          setActive('element', '');
          setActive('chakra', '');
          render();
        });
      });

      if (search) {
        search.addEventListener('input', function () {
          state.q = search.value.trim();
          render();
        });
      }

      updateChakraCounts();
      render();
    }

    function initAll() {
      Array.prototype.slice.call(document.querySelectorAll('[data-kyh-root]')).forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
